import { makeStyles } from "@material-ui/core/styles";

const style = makeStyles((theme) => ({
  category: {
    color: theme.colors.black,
    cursor: "pointer",
    "&:hover": {
      fontWeight: "bold",
    },
    "&:active": {
      color: theme.colors.offWhite,
    },
  },
  links: {
    color: theme.colors.offWhite,
    textDecoration: "none",
    marginLeft: theme.spacing(2),
    "&:hover": {
      fontWeight: "bold",
    },
    "&:active": {
      color: theme.colors.black,
    },
  },
}));

export default style;
